import _ from 'lodash';
import * as routeInitialize from '../Enum/routeInitialize'
import mapping from "./mapping";

interface Initialize {
  [propname: string]: string
}

class myRouter {
  push(this: any, namespace: string, to: string) {
    //state
    let source = this.$store.state[namespace] as any;
    //getters
    let gettersKeys = Object.keys(this.$store.getters).filter(
      (k) => k.indexOf(namespace) != -1
    );
    let gettersItem = _.pick(this.$store.getters, gettersKeys);
    for (let k in gettersItem) {
      source[k.split(namespace + "/")[1]] = gettersItem[k];
    }
    //mapping
    let map: Map<string, string> = new Map();
    let namespaceAppoint: Initialize = (<any>routeInitialize)[namespace + "Initialize"];
    let toAppoint: Initialize = (<any>routeInitialize)[to + "Initialize"];
    for (let p in toAppoint) {
      if (namespaceAppoint[p]) {
        map.set(namespaceAppoint[p], toAppoint[p]);
      }
    }
    let query = mapping.requiredProperties<any, any, any, any>(source, map);
    this.$router.push({
      name: to,
      query
    })
  }
}
export default new myRouter;


// WEBPACK FOOTER //
// ./src/ts/Tool/myRouter.ts